import { useCallback, useMemo } from 'react';

import { useCurrentUserId, useSessionUuid } from '#src/app/shared/hooks/session';
import type { ShareActionsOptions, ShareChannel } from '#src/app/shared/hooks/share';

import type { CommentShareChannel, PartialComment, PartialPetition, ShareConfig } from '../types';

export function useGetCommentShareTrackingData(
	comment: PartialComment,
	petition: PartialPetition,
	{ viewContext }: ShareConfig,
): ShareActionsOptions<CommentShareChannel>['getTrackingData'] {
	const userId = useCurrentUserId();
	const ownPetition = petition.user.id === userId;
	const uuid = useSessionUuid();

	const commonTrackingData = useMemo(
		() => ({
			comment_id: comment.id,
			comment_likes: comment.likes,
			role: comment.role.toLowerCase(),
			own_petition: ownPetition,
			user_id: userId,
			uuid,
			view_context: viewContext,
		}),
		[comment, ownPetition, userId, uuid, viewContext],
	);
	return useCallback((_channel: ShareChannel) => commonTrackingData, [commonTrackingData]);
}
